import {FormLabel, Grid, Typography, useTheme} from "@mui/material";
import React, {useEffect, useState} from "react";
import {isoToLocalDateString} from "../../../stores/StoreUtilities";
import ModelCard2 from "../../../components/model/ModelCard2";
import {EventIcon} from "../../../styles/Icons";
import Model from "../../../model/Model";
import Milestone from "../../../model/Milestone";
import MilestoneEditDialog from "./MilestoneEditDialog";


const MilestoneCard = ({
  milestone,
  model,
  onSave,
  onDelete
}: {
  milestone: Milestone
  model: Model
  onSave?(milestone: Milestone): void
  onDelete?(deleted: Milestone): void
}) => {
  const [milestoneModel, setMilestoneModel] = useState<Milestone>(milestone)
  const [label, setLabel] = useState<string>("")
  const [description, setDescription] = useState<string>("")
  const [milestoneDate, setMilestoneDate] = useState<string>("")
  const [isLocked, setIsLocked] = useState<boolean>(false)
  const [editOpen, setEditOpen] = useState<boolean>(false)

  useEffect(() => {
    init(milestone)
  }, [milestone])

  const init = (milestone: Milestone) => {
    setMilestoneModel(milestone)
    setLabel(milestone.label)
    setMilestoneDate(milestone.date ? isoToLocalDateString(milestone.date) : "")
    setDescription(milestone.description)
    setIsLocked(model.hasLock(milestone.id, "*"))
    setEditOpen(!milestone.createdAt)
  }

  const theme = useTheme()

  const styles = {
    heading: {
      color: theme.palette.primary.main,
      fontWeight: 'bold'
    },
    row: {
      height: 40,
      minHeight: 40,
      maxHeight: 40,
    },
    formLabel: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: "1.0em",
      maxHeight: 15,
      marginBottom: "1px",
      textWrap: "nowrap",
      color: theme.palette.grey["700"]
    }
  }

  const renderContent = () => {
    return (
      <Grid container direction="column" spacing={0}>
        <Grid item xs={12} sx={styles.row}>
          <FormLabel sx={styles.formLabel}>Date</FormLabel>
          <Typography variant="body2">
            {milestoneDate}
          </Typography>
        </Grid>
        {description &&
          <Grid item xs={12} sx={styles.row}>
            <FormLabel sx={styles.formLabel}>Description</FormLabel>
            <Typography variant="body2">
              {description}
            </Typography>
          </Grid>
        }
      </Grid>
    )
  }

  return (
    <ModelCard2
      icon={<EventIcon/>}
      title={<div style={{fontSize:15, paddingBottom:"4px", lineHeight:"1.0em"}}>{label}</div>}
      expanded={true}
      bgColor={isLocked ? theme.palette.grey[100] : undefined}
      editButtonId={`edit-btn-${milestoneModel.id}`}
      onEdit={(event: any) => {
        setEditOpen(!editOpen)
      }}
    >
      {renderContent()}
      {editOpen &&
        <MilestoneEditDialog milestone={milestoneModel} model={model}
                          open={editOpen}
                          onSave={(update: Milestone) => {
                            init(update)
                            setEditOpen(false)
                            if (onSave) {
                              onSave(update)
                            }
                          }}
                          onDelete={(deleted: Milestone) => {
                            setEditOpen(false)
                            if (onDelete) {
                              onDelete(deleted)
                            }
                          }}
                          onClose={() => {
                            setEditOpen(false)
                            if (!milestoneModel.createdAt && onDelete) {
                              onDelete(milestoneModel)
                            }
                          }}/>
      }
    </ModelCard2>
  )
}

export default MilestoneCard